<div class="min-h-screen flex items-center justify-center bg-gray-50">
  <div class="max-w-4xl mx-auto px-6 py-16 text-center">
    <!-- Logo -->
    <div class="mb-8">
      <img src="./assets/sbk1-logo.svg" alt="SBK1 SmartHACCP" class="h-16 mx-auto" />
    </div>
    
    <!-- Error Code -->
    <div class="mb-6">
      <p class="text-9xl font-bold text-gray-200 select-none">{{ errorCode }}</p>
    </div>
    
    <!-- Error Title -->
    <h1 class="text-5xl font-bold text-gray-900 mb-4">
      {{ getErrorTitle() }}
    </h1>
    
    <!-- Error Message -->
    <p class="text-xl text-gray-600 mb-12 max-w-2xl mx-auto">
      {{ errorMessage }}
    </p>
    
    <!-- Beautiful Architecture Image -->
    <div class="mb-12 rounded-lg overflow-hidden shadow-xl">
      <img 
        src="https://images.unsplash.com/photo-1487958449943-2429e8be8625?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=2070&q=80" 
        alt="Architektur" 
        class="w-full h-64 sm:h-96 object-cover" />
    </div>
    
    <!-- Login Button -->
    <div class="mt-8">
      <button 
        mat-raised-button
        color="primary"
        (click)="goToLogin()"
        class="!bg-[#003671] !text-white !px-8 !py-3 !text-base !font-semibold !rounded-lg !shadow-lg hover:!bg-[#004a9e] transition-all duration-200 hover:!shadow-xl">
        <mat-icon class="!mr-2">login</mat-icon>
        Zur Anmeldung
      </button>
    </div>
    
    <!-- Additional Help Text -->
    <div class="mt-8 text-gray-500 text-sm">
      <p>Falls Sie glauben, dass dies ein Fehler ist, kontaktieren Sie bitte den Support.</p>
    </div>
  </div>
</div>
